// #region TypesAndInterfaces
/**
 * Registro esplicito dei file di colori per sito: ogni sito con colori propri ha qui la sua riga.
 *
 * Chiavi: `master:<ID_SiteMaster>` e `site:<ID_Site>`. Si caricano a cascata: prima il file del
 * site master, poi quello dello store, che ridefinisce solo i token che gli servono. Un sito
 * assente dal registro usa i colori di baseStyle.css per scelta; un sito presente il cui file non
 * si carica è un errore, scritto in console. La presenza si dichiara qui, non si indovina.
 *
 * Per aggiungere un sito: generare il file con tools/site-theme (vedi THEMING-GUIDE) e aggiungere
 * qui la riga corrispondente.
 */
export type SiteThemeKey = `master:${number}` | `site:${number}`;
// #endregion TypesAndInterfaces

// #region Constants
export const SITE_THEMES: Readonly<Partial<Record<SiteThemeKey, string>>> = {
  // e-Pol (site master 2): palette blu, prima classe .e-pol di variables.scss
  'master:2': 'assets/themes/master-2.css',
};
// #endregion Constants
